import { createSlice } from '@reduxjs/toolkit';

const isMobile = () => {
	let hasTouchScreen = false;
	if ('maxTouchPoints' in navigator) {
		hasTouchScreen = navigator.maxTouchPoints > 0;
	} else if ('msMaxTouchPoints' in navigator) {
		hasTouchScreen = navigator.msMaxTouchPoints > 0;
	} else {
		const mQ = matchMedia?.('(pointer:coarse)');
		if (mQ?.media === '(pointer:coarse)') {
			hasTouchScreen = !!mQ.matches;
		} else if ('orientation' in window) {
			hasTouchScreen = true; // deprecated, but good fallback
		} else {
			// Only as a last resort, fall back to user agent sniffing
			const UA = navigator.userAgent;
			hasTouchScreen =
				/\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
		}
	}
	return hasTouchScreen;
};

const initialState = {
	sideBarOpen: localStorage.getItem('sidebarOpen') !== 'false' && !isMobile(),
	isCreateShipmentLoading: false,
	themeName: localStorage.getItem('themeName') ?? 'systemTheme',
	darkMode: localStorage.getItem('darkMode') === 'true',
	localization: {
		code: 'engValue',
		name: 'English',
		systemCode: 'en_US',
		dir: 'ltr',
		icon: 'https://storage.googleapis.com/tryoto-public/public/assets/flags/us.svg',
		tinyMCELanguage: undefined,
		tinyMCELanguageUrl: undefined
	},
	loading: false,
	listMapView: false,
	mobile: isMobile()
};

const layout = createSlice({
	name: 'layout',
	initialState,
	reducers: {
		toogleSideBar: (state) => {
			localStorage.setItem('sidebarOpen', !state.sideBarOpen);
			return {
				...state,
				sideBarOpen: !state.sideBarOpen
			};
		},
		setThemeName: (state, action) => {
			localStorage.setItem('themeName', action.payload);
			return {
				...state,
				themeName: action.payload
			};
		},
		setDarkMode: (state, action) => {
			localStorage.setItem('darkMode', action.payload);
			return {
				...state,
				darkMode: action.payload
			};
		},
		setLocalization: (state, action) => ({
			...state,
			localization: action.payload
		}),
		setLoading: (state, action) => ({
			...state,
			loading: action.payload
		}),
		setListMapView: (state, action) => ({
			...state,
			listMapView: action.payload
		}),
		setIsCreateShipmentLoading: (state, action) => ({
			...state,
			isCreateShipmentLoading: action.payload
		})
	}
});

export const {
	toogleSideBar,
	setThemeName,
	setDarkMode,
	setLocalization,
	setLoading,
	setListMapView,
	setIsCreateShipmentLoading
} = layout.actions;

export default layout.reducer;
